import React, { useState } from 'react';
import { IconGrid, IconSearch, IconPlus, IconUpload } from './Icons';
import './TeamTimeCards.css';

const MEMBERS_CLOCKED_IN = [
  { name: 'zubaida almahrizi', date: '2025-12-31', inTime: '08:27:35 am' },
  { name: 'Issa Al Rashdi', date: '2025-11-17', inTime: '10:13:01 am' },
  { name: 'Basil al wahaibi', date: '2025-10-01', inTime: '08:30:01 am' },
  { name: 'Majida Admin', date: '2025-09-29', inTime: '12:35:26 pm' },
  { name: 'Aida Al Zedjali', date: '2025-05-14', inTime: '05:51:26 am' },
];

const DAILY_COLUMNS = [
  { key: 'member', label: 'Team member' },
  { key: 'inDate', label: 'In Date' },
  { key: 'inTime', label: 'In Time' },
  { key: 'outDate', label: 'Out Date' },
  { key: 'outTime', label: 'Out Time' },
  { key: 'duration', label: 'Duration' },
];

export default function TeamTimeCards() {
  const [tab, setTab] = useState('daily'); // daily | custom | summary | summaryDetails | members | clock
  const [showAddModal, setShowAddModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const [visibleColumns, setVisibleColumns] = useState(
    DAILY_COLUMNS.reduce(
      (acc, col) => ({
        ...acc,
        [col.key]: true,
      }),
      {},
    ),
  );
  const [columnMenuOpen, setColumnMenuOpen] = useState(false);

  const toggleColumn = (key) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const activeColumns = DAILY_COLUMNS.filter((col) => visibleColumns[col.key] !== false);

  const isSummaryLike = tab === 'summary' || tab === 'summaryDetails';

  const handleExportExcel = () => {
    const header = ['Team member', 'In Date', 'In Time'];
    const rows = MEMBERS_CLOCKED_IN.map((row) => [row.name ?? '', row.date ?? '', row.inTime ?? '']);
    const csvLines = [header, ...rows].map((cols) =>
      cols
        .map((v) => {
          const s = v == null ? '' : String(v);
          return s.includes('"') || s.includes(',') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(','),
    );
    const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'time-cards-export.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="ttime-page">
      <div className="ttime-card">
        <div className="ttime-header-row">
          <h1 className="ttime-title">Time cards</h1>
          <div className="ttime-header-actions">
            <button
              type="button"
              className="ttime-header-btn"
              onClick={() => setShowAddModal(true)}
            >
              <IconPlus />
              Add time manually
            </button>
            <button
              type="button"
              className="ttime-header-btn ttime-header-btn-primary"
              onClick={() => setShowImportModal(true)}
            >
              <IconUpload />
              Import Time Card
            </button>
          </div>
        </div>

        <div className="ttime-tabs-row">
          <button
            type="button"
            className={`ttime-tab-btn${tab === 'daily' ? ' active' : ''}`}
            onClick={() => setTab('daily')}
          >
            Daily
          </button>
          <button
            type="button"
            className={`ttime-tab-btn${tab === 'custom' ? ' active' : ''}`}
            onClick={() => setTab('custom')}
          >
            Custom
          </button>
          <button
            type="button"
            className={`ttime-tab-btn${tab === 'summary' ? ' active' : ''}`}
            onClick={() => setTab('summary')}
          >
            Summary
          </button>
          <button
            type="button"
            className={`ttime-tab-btn${tab === 'summaryDetails' ? ' active' : ''}`}
            onClick={() => setTab('summaryDetails')}
          >
            Summary details
          </button>
          <button
            type="button"
            className={`ttime-tab-btn${tab === 'members' ? ' active' : ''}`}
            onClick={() => setTab('members')}
          >
            Members Clocked In
          </button>
          <button
            type="button"
            className={`ttime-tab-btn${tab === 'clock' ? ' active' : ''}`}
            onClick={() => setTab('clock')}
          >
            Clock in-out
          </button>
        </div>

        <div className="ttime-filters-row">
          <div className="ttime-filters-left">
            <button
              type="button"
              className="ttime-layout-toggle"
              aria-label="Layout options"
            >
              <IconGrid />
            </button>

            <select className="ttime-filter-select" defaultValue="">
              <option value="">- Member -</option>
            </select>

            {tab === 'daily' && (
              <div className="ttime-date-chip">
                <button type="button" className="ttime-date-arrow" aria-label="Prev day">
                  «
                </button>
                <span className="ttime-date-label">Today</span>
                <button type="button" className="ttime-date-arrow" aria-label="Next day">
                  »
                </button>
              </div>
            )}

            {tab === 'custom' && (
              <>
                <input
                  className="ttime-date-input"
                  defaultValue="27th February 2026"
                  readOnly
                />
                <input
                  className="ttime-date-input"
                  defaultValue="27th February 2026"
                  readOnly
                />
              </>
            )}

            {tab === 'summary' || tab === 'summaryDetails' ? (
              <>
                <input
                  className="ttime-date-input"
                  defaultValue="27th February 2026"
                  readOnly
                />
                <input
                  className="ttime-date-input"
                  defaultValue="27th February 2026"
                  readOnly
                />
              </>
            ) : null}
          </div>

          <div className="ttime-filters-right">
            <button type="button" className="ttime-utility-btn" onClick={handleExportExcel} disabled={MEMBERS_CLOCKED_IN.length === 0}>
              Excel
            </button>
            <div className="ttime-search">
              <input type="text" placeholder="Search" aria-label="Search time cards" />
              <span className="ttime-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        {tab === 'members' ? (
          <div className="ttime-members-wrapper">
            <table className="ttime-table">
              <thead>
                <tr>
                  <th>Team member</th>
                  <th>In Date</th>
                  <th>In Time</th>
                </tr>
              </thead>
              <tbody>
                {MEMBERS_CLOCKED_IN.map((row) => (
                  <tr key={`${row.name}-${row.date}`}>
                    <td>
                      <div className="ttime-member-cell">
                        <div className="ttime-avatar" />
                        <a href="#member" className="ttime-member-link">
                          {row.name}
                        </a>
                      </div>
                    </td>
                    <td>{row.date}</td>
                    <td>{row.inTime}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="ttime-table-wrapper">
            <table className="ttime-table">
              <thead>
                <tr>
                  {isSummaryLike ? (
                    <>
                      <th>Team member</th>
                      <th>{tab === 'summary' ? 'Duration' : 'Date'}</th>
                      {tab === 'summary' ? <th>Hours</th> : <th>Duration</th>}
                      {tab === 'summaryDetails' && <th>Hours</th>}
                    </>
                  ) : (
                    activeColumns.map((col) => <th key={col.key}>{col.label}</th>)
                  )}
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="ttime-empty-cell" colSpan={isSummaryLike ? 5 : activeColumns.length + 1}>
                    No record found.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <div className="ttime-footer-row">
          <div className="ttime-footer-left">
            <select
              className="ttime-page-size"
              defaultValue="10"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            <span>0-0 / 0</span>
          </div>
          <div className="ttime-footer-right">
            <button
              type="button"
              className="ttime-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="ttime-page-btn ttime-page-btn-active"
              aria-label="Current page"
            >
              1
            </button>
            <button
              type="button"
              className="ttime-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Add time manually</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowAddModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">Team member</div>
                <select className="estimates-form-select" defaultValue="">
                  <option value="">-</option>
                </select>

                <div className="estimates-form-label">In Date</div>
                <input className="estimates-form-input" placeholder="In Date" />
                <div className="estimates-form-label">In Time</div>
                <input className="estimates-form-input" placeholder="In Time" />

                <div className="estimates-form-label">Out Date</div>
                <input className="estimates-form-input" placeholder="Out Date" />
                <div className="estimates-form-label">Out Time</div>
                <input className="estimates-form-input" placeholder="Out Time" />

                <div className="estimates-form-label">Note</div>
                <textarea className="estimates-form-textarea" placeholder="Note" />
              </div>
            </div>
            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowAddModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showImportModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowImportModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Import Time Card</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowImportModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="estimates-modal-body">
              <div className="ttime-import-dropzone">
                Drag-and-drop documents here
                <br />
                (or click to browse...)
              </div>
            </div>
            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowImportModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowImportModal(false)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

